<template>
  <Page>
    <div class="md:mt-20 text-whitebase md:px-20">
      <div class="space-y-4" v-if="state.infoStatus">
        <div class="text-4xl font-bold">
          {{ state.info.title }}
        </div>
        <div class="flex justify-between items-center">
          <div class="flex gap-10">
            <div class="flex gap-2 text-xs" v-if="state.info.typeName">
              <div>Type:</div>
              <div class="text-white-040 px-2 rounded-lg bg-white-010">
                {{ state.info.typeName }}
              </div>
            </div>
            <div class="flex gap-2 text-xs" v-if="state.info.tag">
              <div>Tag:</div>
              <div class="px-2">
                {{ state.info.tag }}
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <div class="text-xs pr-2 mr-2 border-r border-whitebase">
              {{ formatBlogTime(state.info.displayDate) }}
            </div>

            <div class="flex gap-2">
              <UiImg
                class="w-6 h-6 rounded-full overflow-hidden object-cover"
                :src="state.info.avatarUrl"
              />
              <div class="text-sm font-bold">{{ state.info.authorName }}</div>
            </div>
          </div>
        </div>
        <div class="pb-4 border-b border-white-010">
          {{ state.info.description }}
        </div>

        <div
          v-html="formattedText(state.info.content)"
          class="blog-content"
        ></div>

        <div class="text-gray-level text-xl text-center">
          <div
            class="my-16 pb-4"
            style="border-bottom: 1px solid rgba(255, 255, 255, 0.1)"
          >
            — END —
          </div>
        </div>
      </div>
      <BlogDetails v-else></BlogDetails>

      <div>
        <div class="text-xl font-bold">FOR MORE</div>
        <div
          class="grid grid-cols-1 md:grid-cols-3 gap-5"
          v-if="state.listStatus"
        >
          <Card v-for="item in state.list" :key="item.id" :info="item"></Card>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-5" v-else>
          <NewsCard v-for="(x, i) in Array(3).fill(0)" :key="i"></NewsCard>
        </div>
      </div>
    </div>
  </Page>
</template>

<script setup>
import { onMounted, reactive, watch } from 'vue';
import { queryBlogDetailByTitle, queryBlogs } from '@/api/common';
import Page from '@/components/Page.vue';
import NewsCard from '@/components/Skeletons/NewsCard.vue';
import BlogDetails from '@/components/Skeletons/BlogDetails.vue';
import Card from './Card.vue';
import { useRoute } from 'vue-router';
import { notify } from '@kyvg/vue3-notification';
import dayjs from 'dayjs';
import UiImg from '@/components/UiImg.vue';

const $route = useRoute();
const formattedText = (rawText) => {
  const regex = /\n/g;
  const matches = rawText.match(regex);

  return rawText;
  // .replace(/(\n{2,})/g, '<br/>');
  // .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
  // .replace(/<p data-selectable-paragraph="">&nbsp;<\/p>/g, '<br>');
};
const state = reactive({
  info: {},
  infoStatus: false,
  list: [],
  listStatus: false,
});

const formatBlogTime = (time) => dayjs(time).format('MMM DD - HH:mm , YYYY');

const loadInfo = async () => {
  try {
    state.infoStatus = false;
    const res = await queryBlogDetailByTitle($route.params.id);
    console.log(res);
    state.info = res.data;
    console.log(res, state.info);
    state.infoStatus = true;
  } catch (error) {
    notify({
      type: 'error',
      text: 'Load Failed',
    });
  }
};

const loadBlogs = async () => {
  try {
    state.listStatus = false;
    const x = await queryBlogs(1, 3);
    console.log(x);
    state.list = x.result;
    state.listStatus = true;
  } catch (error) {
    notify({
      type: 'error',
      text: 'Load Blogs Failed',
    });
  }
};

watch(
  () => $route.params.id,
  (val) => {
    state.list = [];
    state.info = {};
    loadInfo();
    loadBlogs();
  },
);

onMounted(() => {
  loadInfo();
  loadBlogs();
});
</script>

<style>
.blog-content ol {
  list-style: inherit;
  padding: revert;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
.blog-content ul {
  list-style: inherit;
  padding: revert;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
.blog-content p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.blog-content h1 {
  display: block;
  font-size: 2em;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.blog-content figure {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 40px;
  margin-inline-end: 40px;
}
@media (max-width: 768px) {
  .blog-content span {
    width: 100% !important;
    height: auto !important;
  }
  .blog-content p {
    word-break: break-all;
  }
}
</style>
